<div class="card mt-1">
  <div class="card-body">
    <div class="row">
      <div class="col-9">
        <h4>Verification</h4>
      </div>
      <div class="col-3">
        <app-verified-invalid-reviewed [capture]="capture" />
      </div>
    </div>

    @if (!processing) {
      <div>
        @if (canEdit) {
          <app-verification-outcome-status
            [capture]="capture"
            [patientPrescriberNote]="patientPrescriber.latestNote"
            />
          <app-verification-outcome-form
            [capture]="capture"
            [showValidationSummary]="showValidationSummary"
            (transitionChange)="onTransitionChange()"
            (processOutcome)="onProcessOutcome($event)"
            [patientPrescriberNote]="patientPrescriber.latestNote"
            />
        }
        @if (!canEdit) {
          <div>{{ capture.status | captureStatus }}</div>
        }
        @if (showClientPrescriber) {
          <app-capture-client-prescriber [capture]="capture" />
        }
      </div>
    } @else {
      <div class="py-2">
        <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
        Processing match...
      </div>
    }
    @if (serverError) {
      <div class="alert alert-danger">
        A server error occurred while processing this match. Please try again or contact support.
        <div class="server-errors">
          <table>
            <thead class="table-dark">
              {{
              serverErrorResponse.summary
              }}
            </thead>
            @for (serverErrorDetail of serverErrorResponse.details; track serverErrorDetail) {
              <tr>
                <td>{{ serverErrorDetail }}</td>
              </tr>
            }
          </table>
        </div>
      </div>
    }
    @if (clientError) {
      <div class="alert alert-danger">
        {{ clientError }}
      </div>
    }
  </div>
</div>
